import React, {useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Card, Row, Col, List, Divider, Button, Form, Upload, Select, Modal } from 'antd';
import { PlusOutlined } from '@ant-design/icons';
import { motion } from 'motion/react';
import { getConfirmedPlayer, getIssuedPlayer } from '../../utils/DataUtils';
import { useTranslation } from 'react-i18next';

function ImportTournamentResults(props) {
  const [platform, setPlatform] = useState(null);
  const [fileList, setFileList] = useState([]);
  const [confirmedResult, setConfirmedResult] = useState([]);
  const [issuedResult, setIssuedResult] = useState([]);
  const [confirmModalVisible, setConfirmModalVisible] = useState(false);
  let navigate = useNavigate();

  function handleConfirmSave() {
    setConfirmModalVisible(false);
    // Proceed with saving the results
  }

  const uploadProps = {
      onRemove: file => {
      const index = fileList.indexOf(file);
      const newFileList = fileList.slice();
      newFileList.splice(index, 1);
      setFileList(newFileList);
      },
      beforeUpload: file => {
      setFileList([...fileList, file]);
      return false;
      },
      fileList,
  };
  const { t } = useTranslation();

  // console.warn('props di ImportTournamentResults', props);
  useEffect(() => {
    setConfirmedResult(getConfirmedPlayer(props.previewResults))
    setIssuedResult(getIssuedPlayer(props.previewResults))
  }, [props.previewResults])

  function generateOptions(options) {
    // console.warn('option is:', options);
    if (!options) {
      return [{value: 0, label: 'New Player'},{value: -1, label: 'Existing Player'}]
    }
    
    let playerOpts = [];
    options.forEach(element => {
      let opt = {value: element.id, label: element.firstName+' '+element.lastName }
      playerOpts.push(opt);
    });
    playerOpts.push({value: 0, label: 'New Player'})
    playerOpts.push({value: -1, label: 'Existing Player'})
    return playerOpts;
  }

  function generatePlayerOptions(options) {
    // console.warn('option is:', options);
    if (!options) {
      return []
    }
    
    let playerOpts = [];
    options.forEach(element => {
      let opt = {value: element.id, label: element.firstName+' '+element.lastName }
      playerOpts.push(opt);
    });
    return playerOpts;
  }

  async function onFinish(event) {
    event.preventDefault();
    // console.warn('what platform was chosen?', platform);
    // console.warn('files to upload?', fileList);
    props.importResults.mutate({tournamentId: props.id, platform: platform, file: fileList[0]});
  }

  function onSaveResults(event) {
    event.preventDefault();
    let unresolvedIssues = 0;
    if (issuedResult.length > 0) {
      issuedResult.forEach((item) => {
        if (!item.hasOwnProperty('selectedPlayer') || item.selectedPlayer < 0) {
          unresolvedIssues += 1;
        }
      });
    }
    if (unresolvedIssues > 0) {
      setConfirmModalVisible(true);
      return;
    }
    if (confirmModalVisible === false) {
      // console.warn('qua devo far partire la chiamata verso i ws per salvare la classifica importata.');
      saveData();
    }
  }

  function saveData() {
    let savingResults = [];
    // Merging confirmed results and corrected issued results
    confirmedResult.forEach((participant) => {
      participant.platform = platform;
      savingResults.push(participant);
    });
    issuedResult.forEach((item) => {
      item.platform = platform;
      savingResults.push(item);
    });
    // console.warn('final results to save:', savingResults);
    // Call the save function with the final results
    props.saveImportedResults.mutate({tournamentId: props.id, results: savingResults});
  }

  function handleChange(value,index) {
    // console.warn('changed item value with index:', index, ' to value:', value);
    const updatedIssuedResult = issuedResult.map((item,idx) => {
      if (idx === index) {
        if ( value === -1 ) {
          item.existingPlayer = true;
        }
        item.selectedPlayer = value;
        return item;
      } else {
        return item
      }
    })
    setIssuedResult(updatedIssuedResult);
    // issuedResult[index].selectedPlayer = value;
  }

  function handleRedirect() {
    // Redirect to tournament page
    navigate('/tournaments/' + props.id);
  }

  const tournament = (props.tournament.data && props.tournament.data.payLoad !== null ? props.tournament.data.payLoad : {});
  const platforms = (props.platforms.data && props.platforms.data.payLoad !== null ? props.platforms.data.payLoad : []);
  
  return (
      <motion.div initial={{opacity: 0}} animate={{opacity: 1}} exit={{opacity: 0}} className="content-body">
      <Card loading={props.tournament.pending || props.players.pending} title={tournament.name} style={{ marginTop: '24px' }}>
        <Row gutter={16} justify="center">
            <Select 
                placeholder="Select platform" 
                options={platforms.map((platform) => ({
                    value: platform.name.toLowerCase(),
                    label: <span>{platform.name}</span>
                }))}
                onChange={(value) => setPlatform(value)}
            />
        </Row >
        <Divider>Preview Results</Divider>  
        <Row gutter={16} justify="center" style={{ marginBottom: '16px' }}>
          <Col span={24}>
            { platform === null && 
              <p>Please select the platform used in the event.</p>
            }
            { platform !== null &&
            <div> 
              <p>Upload the csv downloaded from the selected platform.</p>
              <Upload {...uploadProps} listType="picture-card" maxCount={1}>
                  <button
                  style={{ color: 'inherit', cursor: 'inherit', border: 0, background: 'none' }}
                  type="button"
                  >
                  <PlusOutlined />
                  <div style={{ marginTop: 8 }}>Upload</div>
                  </button>
              </Upload>
            </div>
            }
          </Col>
        </Row>
        <Row justify="center">
          <Col span={4}>
            <Button type="primary" onClick={onFinish} disabled={platform === null || fileList.length === 0}>Import Results</Button>
          </Col>
          <Col span={4}>
            <Button type="primary" onClick={onSaveResults} disabled={props.previewResults.length === 0}>Save Results</Button>
            <Modal
              title="Actions needed"
              open={confirmModalVisible}
              onOk={handleConfirmSave}
              footer={(_, { OkBtn, CancelBtn }) => (
                <>
                  <OkBtn />
                </>
            )}
            >
              <p>There are some issues with the player import. Please review and correct them before saving.</p>
            </Modal>
            <Modal
              title="Import Done"
              open={props.successfulImportFlag}
              onOk={handleRedirect}
              footer={(_, { OkBtn, CancelBtn }) => (
                <>
                  <OkBtn />
                </>
              )}
            >
              <p>Results have been successfully imported and saved! Click to return to the tournament page.</p>
            </Modal>
          </Col>
        </Row>
        {props.loading !== null &&
          <Row justify="center">
          <Card loading={props.loading} style={{ border: 'none', width: '100%' }}>
            <b>{props.previewResults.length} participant detected.</b> <br/>
            <b>There are {issuedResult.length} participants that have some issue!</b>
            <List
              dataSource={issuedResult}
              renderItem={(item, index) => (
                <List.Item key={item.key} itemKey={item.key}>
                  <Row style={{ width: '95%'}}>
                    <Col xs={6} sm={6} md={2} lg={2} xl={2}>
                      {item.rankingPlace}
                    </Col>
                    <Col xs={6} sm={6} md={2} lg={2} xl={2}>
                      {item.score}
                    </Col>
                    <Col xs={18} sm={18} md={7} lg={7} xl={7}>
                      { (item.playerName !== "" || item.playerSurname !== "") && `${item.playerName} ${item.playerSurname}`}
                      { (item.playerName === "" && item.playerSurname === "") && `${item.playerId}` }
                    </Col>
                    <Col xs={24} sm={24} md={7} lg={7} xl={7}>
                      <Select style={{ width: '45%' , marginRight: '5px'}} onChange={(e) => handleChange(e,index)} options={generateOptions(item.possibileMatches)} placeholder="Select a player"/>
                      { item.existingPlayer && item.selectedPlayer != 0 &&
                        <Select showSearch optionFilterProp="children" filterOption={(input, option) => option.label.toLowerCase().includes(input.toLowerCase())} style={{ width: '45%', marginLeft: '5px' }} onChange={(e) => handleChange(e, index)} options={generatePlayerOptions(props.players.data.payLoad)} placeholder="Digita il cognome" />
                      }
                    </Col>
                    <Col xs={24} sm={24} md={6} lg={6} xl={6}>
                      {item.deckName}
                    </Col>
                  </Row>
                </List.Item>
              )}
            />
          </Card>
          </Row>
        }
      </Card>
      </motion.div>
  );
}

export default ImportTournamentResults;